import { useQuery, type UseQueryOptions } from "@tanstack/react-query";

import { getSelectionPipelines } from "@/api/selection-api";
import { type SelectionPipelineConfiguration } from "@/schemas/routing/selection-pipeline";

export const SELECTION_PIPELINES_QUERY_KEY = ["selection-pipelines"] as const;

type UseSelectionPipelinesOptions = Omit<
	UseQueryOptions<SelectionPipelineConfiguration[], Error, SelectionPipelineConfiguration[], readonly string[]>,
	"queryKey" | "queryFn"
>;

export const useSelectionPipelines = (queryConfig: UseSelectionPipelinesOptions = {}) => {
	const query = useQuery({
		queryKey: SELECTION_PIPELINES_QUERY_KEY,
		queryFn: getSelectionPipelines,
		...queryConfig,
	});

	return {
		data: query.data,
		isLoading: query.isLoading,
		error: query.error,
		refresh: query.refetch,
	};
};
